export default "__VITE_ASSET__9d2571e4__"